export function formatCode(str, separator = '-') {
  if (!str) return ''

  const [first, second] = str.split('::')
  return second ? `${first}${separator}${second}` : first
}

export function getRowLabel(rowId) {
  const match = rowId.match(/^([^:]+)(?:::([^_]+))?/)

  if (!match) return rowId

  return match[2] ? `${match[1]}-${match[2]}` : match[1]
}
